import { storage } from '@guardian/libs';
import { getWeeklyArticleHistory, incrementWeeklyArticleCount, } from '@guardian/support-dotcom-components';
import { hasOptedOutOfArticleCount } from '../web/lib/contributions';
import { getDailyArticleCount, incrementDailyArticleCount, } from '../web/lib/dailyArticleCount';
// We should monitor this function call to ensure it only happens within an
// article pages when other pages are supported by DCR.
export const getArticleCounts = async (pageId, keywordIds) => {
    if (await hasOptedOutOfArticleCount())
        return undefined;
    // hasOptedOut needs to be done before we check if articleCount is set in the window
    // This is because a potential race condition where one invocation of getArticleCounts
    // is waiting for hasOptedOut another invocation might receive it and increment the article count.
    if (!window.guardian.weeklyArticleCount) {
        incrementWeeklyArticleCount(storage.local, pageId, keywordIds.split(','));
        window.guardian.weeklyArticleCount = getWeeklyArticleHistory(storage.local);
    }
    if (!window.guardian.dailyArticleCount) {
        incrementDailyArticleCount();
        window.guardian.dailyArticleCount = getDailyArticleCount();
    }
    return {
        weeklyArticleHistory: window.guardian.weeklyArticleCount || [],
        dailyArticleHistory: window.guardian.dailyArticleCount || [],
    };
};
